
import React, { Component } from 'react';
import { connect } from 'react-redux';
import WriteBox from "../WriteBox/index";
import {Card} from '@material-ui/core'
import Auxiliary from "../../../../../util/Auxiliary";
import { getFlodeByUser,addNowFlodeByUser } from 'actions'
import { isEmpty } from 'lodash';
import CustomScrollbars from "./Scrollbars";
import Skeleton from '@mui/material/Skeleton';
const PostItem = React.lazy(() => import('./PostItem'));

function mapStateToProps({auth,Intranet}) {
  const { authUser, currentUserPicUrl} = auth;
  const { isloading,Folde,message} = Intranet;
  return {
    authUser,isloading,Folde,message, currentUserPicUrl
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFlodeByUser: (userid,Afid) => dispatch(getFlodeByUser(userid,Afid)),
    addNowFlodeByUser: (userid,nKommentar,Afid) => dispatch(addNowFlodeByUser(userid,nKommentar,Afid)),
    dispatch
  };
}

class PostList extends Component {
  state = {
    postList: [],
    user: {},
    Flode:[],
    message:"",
    showMessage:false,
    count: 10,
  }
  intervalID = null
  componentWillMount() {
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    this.props.getFlodeByUser(userid,Afid)
    this.intervalID = setInterval(
      () => {
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      this.props.getFlodeByUser(userid,Afid)
      },
     180000
  );
  /*
    if(isEmpty(this.props.Folde)){
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      this.props.getFlodeByUser(userid,Afid)
    }
      this.setState({
        Flode:this.props.Folde
      })
*/
    
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
}
  
  componentDidUpdate=()=>{
    if(this.state.Flode !== this.props.Folde){
      this.setState({
        Flode:this.props.Folde,
        message:this.props.message,
        showMessage:isEmpty(this.props.message)?false:true
      })
      this.setState({postList: this.props.postList, user: this.props.user})
    }
  }
  /**/
  AddNewFlode=(nKommentar)=>{
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    this.props.addNowFlodeByUser(userid,nKommentar,Afid)
  }
  /*
  addPost(commentText, imageList) {

    const post = {
      id: Math.random() * 1343300,
      text: commentText,
      user: this.state.user,
      date: new Date().toString(),
      mediaList: imageList.map(data => {
        return {image: data.preview}
      }),
      viewCount: 0,
      likeCount: 0,
      isLike: false,
      commentCount: 0,
      commentList: [],
    };
    console.log("Post Data :==()==>", post)

    let postArray = this.state.postList;
    postArray.unshift(post);
    this.setState({
      postList: postArray
    });
  }
*/

  BufferFlode= ()=> {
    if(this.state.count < this.state.Flode.length && !isEmpty(this.state.Flode)) {
      console.log('BufferFlode', this.state.Flode.length)
      console.log('BufferFlode', this.state.count)

      this.setState({
        count: this.state.count + 10
      })
    }
  } 

  render() {
    return (
      <Auxiliary>
        <Card className="mb-1" elevation={3}>
          <WriteBox 
          authUser={this.props.authUser}
          currentUserPicUrl={this.props.currentUserPicUrl}
          AddNewFlode={this.AddNewFlode} 
          />
        </Card>
        {/**/}
        <CustomScrollbars style={{height: '100%'}} onReachedBottom={this.BufferFlode}>
          <React.Suspense fallback={<div className="w-100">
            <Skeleton variant="rounded" className={"mt-2"} width="100%" height={148}/>
            <Skeleton variant="rounded" className={"mt-2"} width="100%" height={148}/>
            <Skeleton variant="rounded" className={"mt-2"} width="100%" height={148}/>
            <Skeleton variant="rounded" className={"mt-2"} width="100%" height={148}/>
            <Skeleton variant="rounded" className={"mt-2"} width="100%" height={148}/>
          </div>}>
            {
            isEmpty(this.state.Flode)?"":
            this.state.Flode.slice(0, this.state.count).map((post) => {
                return <PostItem key={post.id} index={post.id} postData={post}/>
              }
            )}
          </React.Suspense>
        </CustomScrollbars>
      </Auxiliary>
    );
  }
}

export default connect(
  mapStateToProps,mapDispatchToProps
)(PostList);

